var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconListing = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.862 1H13.316L2.091 12.351C.73 13.727.628 15.835 1.865 17.055l7.206 7.108c1.236 1.22 3.343 1.09 4.706-.285L25 12.526V1h-.138Z",
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.293 6.683c.673.664 1.753.66 2.414-.009a1.703 1.703 0 0 0-.021-2.412 1.707 1.707 0 0 0-2.415.01 1.703 1.703 0 0 0 .022 2.411Z",
  stroke: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m13.719 8.511-7.4 7.57",
  stroke: "currentcolor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m15.564 10.309-7.4 7.57M17.237 11.943l-7.397 7.57",
  stroke: "currentColor"
})));

export default SvgIconListing;